/**
 * 24bottles — analytics bridge
 *
 * Publishes DataClinic measurement-plan events through Shopify.analytics so GTM
 * can consume them. One file, no framework.
 * Exception: section_click (handler 7) pushes straight to window.dataLayer,
 * per the Tillde "click to purchase" spec (GTM is loaded in theme.liquid).
 * Lead forms (JotForm, Globo) are not tracked here: see handlers 3, 4 & 6.
 */

const DEBUG = false;

function publish(event, payload) {
  try {
    window.Shopify?.analytics?.publish?.(event, payload);
    if (DEBUG) console.log('[24-analytics]', event, payload);
  } catch (_) { /* swallow: tracking must never break the page */ }
}

window.trackAnalytics = publish;

/* -------------------------------------------------------------------------- */
/* 1 & 1b. begin_personalization (dual-emit)                                   */
/* -------------------------------------------------------------------------- */

function resolveListFromNavigation() {
  const map = window.__cz_collectionMap || {};
  const lookup = (handle) => ({ id: map[handle] != null ? String(map[handle]) : '', name: handle });
  const fromPath = window.location.pathname.match(/\/collections\/([^/]+)/);
  if (fromPath) return lookup(fromPath[1]);
  try {
    const ref = new URL(document.referrer);
    if (ref.origin === window.location.origin) {
      const fromRef = ref.pathname.match(/\/collections\/([^/]+)/);
      if (fromRef) return lookup(fromRef[1]);
    }
  } catch (_) { /* invalid or empty referrer */ }
  return { id: '', name: '' };
}

function onCustomizeClick(e) {
  const a = e.target.closest('[data-analytics="begin_personalization"]');
  if (!a) return;

  const d = a.dataset;
  const list = d.itemListName ? { id: d.itemListId, name: d.itemListName } : resolveListFromNavigation();

  const payload = {
    product_id: d.productId,
    product_title: d.productTitle,
    variant_id: d.variantId,
    sku: d.sku,
    vendor: d.vendor,
    item_list_id: list.id,
    item_list_name: list.name,
    size: d.size,
    colour: d.colour,
    family: d.family,
    finishing: d.finishing,
    final_price: d.finalPrice,
    currency: d.currency,
    quantity: '1',
  };
  if (d.totalDiscount) payload.total_discount = d.totalDiscount;

  publish('24bottles:begin_personalization', payload);
  publish('24lab:begin_personalization', payload);
}

document.addEventListener('click', onCustomizeClick);

/* -------------------------------------------------------------------------- */
/* 2. configurator_step — DISATTIVATO (2026-09-11)                            */
/* -------------------------------------------------------------------------- */

/*
 * Duplicava 24bottles:configurator_step: l'app Vue (assets/customizer.js,
 * trackConfiguratorStep) lo emette gia' su load / cambio step / buy, con i dati
 * completi (variant_id, colour, total_price, accessories).
 *
 * Questa versione invece fa scraping del DOM e legge il prodotto da
 * window.__cz_productContext, popolato in sections/customizer-section.liquid
 * SOLO dai query param dell'URL: variant_id / product_title / colour sono
 * sempre vuoti, e senza ?ids= lo e' anche product_id. Essendo agganciata a
 * ?currentStepIndex + popstate + MutationObserver (debounce 200ms), partiva
 * subito dopo quella di Vue -> in GTM arrivavano due 24lab:configuration
 * identici di fila, il secondo vuoto.
 *
 * Codice lasciato in piedi ma non piu' attivato: vedi il blocco di init in
 * fondo alla sezione.
 */

function initConfiguratorObserver() {
  const app = document.getElementById('app');
  const labels = window.customizerLabels;
  if (!app || !labels) return;

  const titleToName = {};
  if (labels.steps_title) {
    for (const key of Object.keys(labels.steps_title)) {
      const title = labels.steps_title[key];
      if (title) titleToName[String(title).trim().toLowerCase()] = key;
    }
  }

  const ctx = window.__cz_productContext || {};
  let lastStepIndex = null;
  let debounceId = null;

  function readActiveStepTitle() {
    const candidates = app.querySelectorAll('h1, h2, h3, h4, [class*="step-title"], [class*="stepTitle"]');
    for (const el of candidates) {
      const txt = (el.textContent || '').trim().toLowerCase();
      if (txt && titleToName[txt]) return { title: txt, name: titleToName[txt] };
    }
    return null;
  }

  function readStepIndexFromUrl() {
    const p = new URLSearchParams(window.location.search);
    const n = parseInt(p.get('currentStepIndex'), 10);
    return Number.isFinite(n) ? n : null;
  }

  function readStepIndexFromDom() {
    const badge = app.querySelector('[class*="active"][class*="step"], [aria-current="step"]');
    if (!badge) return null;
    const n = parseInt((badge.getAttribute('data-step') || badge.textContent || '').replace(/\D+/g, ''), 10);
    return Number.isFinite(n) ? n : null;
  }

  function readTotalSteps() {
    const stepper = app.querySelector('[class*="stepper"], [class*="steps-nav"], nav');
    if (stepper) {
      const items = stepper.querySelectorAll('[class*="step"]');
      if (items.length) return items.length;
    }
    return null;
  }

  function readTotalPrice() {
    const priceEl = app.querySelector('[class*="total-price"], [class*="totalPrice"], [class*="price-total"]');
    if (!priceEl) return null;
    const m = (priceEl.textContent || '').match(/[\d.,]+/);
    if (!m) return null;
    return parseFloat(m[0].replace(/\.(?=\d{3}\b)/g, '').replace(',', '.'));
  }

  function emit() {
    const stepInfo = readActiveStepTitle();
    if (!stepInfo) return;
    const stepIndex = readStepIndexFromUrl() ?? readStepIndexFromDom();
    if (stepIndex == null) return;
    if (stepIndex === lastStepIndex) return;
    lastStepIndex = stepIndex;

    const totalSteps = readTotalSteps();
    const totalPrice = readTotalPrice();

    const payload = {
      product_id: ctx.product_id,
      variant_id: ctx.variant_id,
      product_title: ctx.product_title,
      size: ctx.size,
      colour: ctx.colour,
      currency: ctx.currency,
      quantity: 1,
      step_name: stepInfo.name,
      step_index: stepIndex,
    };
    if (totalSteps != null) payload.total_steps = totalSteps;
    if (totalPrice != null) payload.total_price = totalPrice;

    publish('24bottles:configurator_step', payload);
  }

  function schedule() {
    if (debounceId) clearTimeout(debounceId);
    debounceId = setTimeout(emit, 200);
  }

  const mo = new MutationObserver(schedule);
  mo.observe(app, { childList: true, subtree: true, attributes: true });
  window.addEventListener('popstate', schedule);
  schedule();
}

// Init disattivato: l'evento e' gia' emesso da assets/customizer.js.
// if (document.getElementById('app') && window.customizerLabels) {
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', initConfiguratorObserver);
//   } else {
//     initConfiguratorObserver();
//   }
// }

/* -------------------------------------------------------------------------- */
/* 3, 4 & 6. JotForm / Globo leads: tracked by Tillde in GTM, not here        */
/* -------------------------------------------------------------------------- */

/*
 * wholesale_lead, brand_product_quotation, sponsorship_submit and
 * application_submit are pushed to the dataLayer by Tillde's Custom HTML
 * listener in GTM (guard window.__tldLeadForms). The JotForm forms live in a
 * jotform.com iframe, so their user data and fields reach Tillde's tracking
 * server through a JotForm webhook instead.
 *
 * The handlers that used to live here never fired: they expected the string
 * 'submission-completed:<id>:<form>' and the Globo form 72961, while JotForm
 * posts an object and the careers page uses 72964. They were removed on
 * 2026-10-07 because the GTM listener handles both of those too, so reviving
 * them would count every submission twice. Ask Tillde before adding code for
 * these forms.
 */

/* -------------------------------------------------------------------------- */
/* 5. newsletter_signup + sms_signup (Klaviyo forms: footer and popup)        */
/* -------------------------------------------------------------------------- */

/*
 * Klaviyo fires a 'submit' for every step of a form. The popup has two steps
 * (email, then mobile number with SMS/WhatsApp consent), the footer form
 * (snippets/klaviyo-form.liquid) only one. So, once per form:
 *  - newsletter_signup on the first submit carrying an email;
 *  - sms_signup on the first submit carrying a phone number, with the email of
 *    the earlier step to tie both to the same person. Skipped when the
 *    optional SMS consent box was left unticked.
 * Embedded forms sit in a .klaviyo-form-<formId> container, the popup does
 * not: that is what tells newsletter_position apart.
 * Email and phone go out in clear text (Klaviyo already sends the phone in
 * E.164): Tillde's Custom Pixel normalises and hashes them.
 */

const klaviyoSteps = {};

function klaviyoValue(detail, keys) {
  for (const key of keys) {
    for (const source of [detail.metaData, detail.formData]) {
      const value = source?.[key];
      if (value != null && value !== '') return String(value);
    }
  }
  return '';
}

window.addEventListener('klaviyoForms', (e) => {
  const d = e.detail;
  if (d?.type !== 'submit') return;

  const formId = d.formId || '';
  const position = formId && document.getElementsByClassName(`klaviyo-form-${formId}`).length ? 'footer' : 'popup';
  const state = klaviyoSteps[formId] || (klaviyoSteps[formId] = {});
  const email = klaviyoValue(d, ['$email', 'email']);
  const phone = klaviyoValue(d, ['$phone_number', 'phone_number']);
  if (email) state.email = email;

  if (email && !state.newsletter) {
    state.newsletter = true;
    publish('newsletter_signup', { newsletter_position: position, form_id: formId, user_data: { email } });
  }

  if (phone && !state.sms && klaviyoValue(d, ['opt_in_promotional_sms']) !== 'false') {
    state.sms = true;
    publish('sms_signup', {
      newsletter_position: position,
      form_id: formId,
      user_data: { phone_number: phone, email: state.email || '' },
    });
  }
});

/* -------------------------------------------------------------------------- */
/* 7. section_click (clicks on tracked sections/blocks → GTM dataLayer)        */
/* -------------------------------------------------------------------------- */

/*
 * Static parameters come from the data-sc-* attributes rendered by
 * snippets/24-section-click.liquid; scroll, section_position and the UUID
 * section_click_id are computed here at click time.
 *
 * Option A of the Tillde "da click a acquisto" plan also requires the theme to
 * persist the last click in localStorage (key: last_section_click). GTM reads
 * it, resolves (none)/(expired) and the 7-day window from `timestamp`, and
 * propagates it as GA4 user properties; the checkout custom pixel re-reads it
 * on purchase as a redundancy check.
 */

const LAST_SECTION_CLICK_KEY = 'last_section_click';

function sectionClickId() {
  try {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  } catch (_) { /* fall through to the manual UUID */ }
  // RFC4122-ish v4 fallback for older WebViews.
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}

function scrollPercent() {
  const max = document.documentElement.scrollHeight - window.innerHeight;
  if (max <= 0) return 0;
  return Math.min(100, Math.max(0, Math.round((window.scrollY / max) * 100)));
}

function sectionPositionOf(el) {
  const sectionEl = el.closest('.shopify-section') || el;
  const top = sectionEl.getBoundingClientRect().top + window.scrollY;
  if (top < window.innerHeight) return 'above';
  if (top >= document.documentElement.scrollHeight * (2 / 3)) return 'bottom';
  return 'center';
}

function onSectionClick(e) {
  const el = e.target.closest?.('[data-section-click]');
  if (!el) return;

  try {
    const d = el.dataset;
    const link = el.closest('a[href]');
    const payload = {
      event: 'section_click',
      page_type: d.scPageType || '',
      creative_slot: d.scCreativeSlot || '',
      banner_position: parseInt(d.scBannerPosition, 10) || 0,
      creative_name: d.scCreativeName || 'PARSE_FAILED',
      creative_date: d.scCreativeDate || 'PARSE_FAILED',
      promotion_name: d.scPromotionName || 'PARSE_FAILED',
      banner_destination: d.scDestination || (link ? link.getAttribute('href') : ''),
      section_type: d.scSectionType || '',
      section_position: sectionPositionOf(el),
      cta_text: d.scCtaText || '',
      scroll: scrollPercent(),
      section_click_id: sectionClickId(),
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    try {
      window.localStorage.setItem(LAST_SECTION_CLICK_KEY, JSON.stringify({
        creative_slot: payload.creative_slot,
        section_type: payload.section_type,
        promotion_name: payload.promotion_name,
        creative_name: payload.creative_name,
        creative_date: payload.creative_date,
        banner_destination: payload.banner_destination,
        section_click_id: payload.section_click_id,
        timestamp: Date.now(),
      }));
    } catch (_) { /* storage unavailable (private mode / blocked): the event still tracks */ }

    if (DEBUG) console.log('[24-analytics]', 'section_click', payload);
  } catch (_) { /* swallow: tracking must never break the page */ }
}

document.addEventListener('click', onSectionClick);
